module.exports = __webpack_public_path__ + "static/img/LI.aed8b981.png";